var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFishWeight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.812,
    height: 34.922,
    viewBox: "0 0 62.812 34.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.394,
    height: 28.152,
    fill: "#004878"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2779.802 -506.039)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62.812,
    height: 4.693,
    transform: "translate(2779.802 529.525)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 49.62,
    height: 4.693,
    transform: "translate(2786.398 536.268)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.407,
    height: 4.693,
    transform: "translate(2783.934 536.268)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.407,
    height: 4.693,
    transform: "translate(2837.13 536.268)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2831.03 527.191) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.079 -7)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.06,42.669a14.486,14.486,0,0,0,2.482-12.69c.58-.072,1.153-.192,1.728-.205a20.111,20.111,0,0,1,7.03,1.235c2.6.894,5.139,1.961,7.7,2.962a10.772,10.772,0,0,0,5.114,1.016c-2.428,0-4.515-1.067-6.613-2.091a45.348,45.348,0,0,0-9.725-3.722,12.878,12.878,0,0,0-5.341-.351.416.416,0,0,1-.353-.161c-.462-.9-.9-1.8-1.4-2.828,1.3-.139,2.578-.326,3.862-.4,5.482-.331,10.334,1.506,14.87,4.394,1.081.688,2.126,1.436,3.234,2.076a4.942,4.942,0,0,0,3.826.835,8.691,8.691,0,0,0,2.647-1.3c2.329-1.671,1.479-.693,3.178-2.775a4.387,4.387,0,0,0,0-3.232,4.424,4.424,0,0,1,3.5,5.953,6.06,6.06,0,0,1-2.834,3.2c-.2.114-.4.22-.6.332-.015.008-.022.03-.061.086.1.064.2.137.3.192a6.41,6.41,0,0,1,3.674,6.252,12.632,12.632,0,0,1-1.253,5.151c-.458-.877-.86-1.692-1.3-2.485a17.123,17.123,0,0,0-4.857-5.807,5.2,5.2,0,0,0-6.217-.266c-1.365.845-2.672,1.789-4.06,2.594-5.746,3.335-11.846,3.8-18.188,2.145-.088-.023-.174-.055-.336-.106",
    transform: "translate(-85.889 -20.638)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.051,56.549a12.91,12.91,0,0,1-2.778,7.987c-.118.149-.425.309-.568.256A20.14,20.14,0,0,1,.266,57.971a.988.988,0,0,1-.124-1.187,14.642,14.642,0,0,1,7.431-6.941c.781-.353,1.613-.591,2.414-.9a.628.628,0,0,1,.882.3,13.347,13.347,0,0,1,2.182,7.3m-6.575.071a1.129,1.129,0,1,0-1.119-1.134A1.127,1.127,0,0,0,6.475,56.62",
    transform: "translate(0 -43.243)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.747,205.545l.783,4.119c-3.549.639-8-1.783-9.865-4.427a26.743,26.743,0,0,0,9.082.308",
    transform: "translate(-98.813 -181.615)",
    fill: "#004878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.015.118l-1.108,2.519a36.767,36.767,0,0,0-9.092-.229,15.887,15.887,0,0,1,10.2-2.291",
    transform: "translate(-95.452 -13.081) rotate(8)",
    fill: "#004878",
    stroke: "#004878",
    strokeWidth: 0.5
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFishWeight);
export default __webpack_public_path__ + "static/media/fishWeight.8afcbd50300b82db31b86d55be0e6ee5.svg";
export { ForwardRef as ReactComponent };